import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { DOCUMENT, inject, isDevMode } from '@angular/core';
import { Router } from '@angular/router';

import { getTaxEnv } from '../environments';
import { EnvironmentDetectorService } from '../service';

/**
 * 支付路由拦截守卫
 * 用于拦截特定路由(eliboo-pay)并根据环境条件进行重定向
 */
export const payRouteInterceptorGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  console.log('[RouteInterceptor] 路由拦截守卫触发:');

  try {
    const currentPath = state.url.split('?')[0];
    if (!isElibooPayRoute(currentPath)) return true;

    const router = inject(Router);
    const document = inject(DOCUMENT);
    const environmentDetector = inject(EnvironmentDetectorService);
    const env = getTaxEnv();
    const h5PayBasePath = env.h5PayBasePath;

    // const getAuthUrl = useGetAuthUrl().genAuthUrl;

    const queryParams = route.queryParams;

    console.log('[RouteInterceptor] 路由拦截守卫触发:', state, route, document.location);
    // 检测环境
    const envResult = environmentDetector.detectEnvironment();
    console.log('[RouteInterceptor] 环境检测结果:', envResult);

    const queryString = new URLSearchParams(queryParams);
    let originUrl = queryString.get('originUrl') ?? h5PayBasePath;
    const isRenewal = queryParams['isRenewal'] === 'true';
    if (isRenewal) {
      originUrl = h5PayBasePath.replace('eliboo-pay', 'qr-code-pay');
    }
    console.log('originUrl', originUrl, isRenewal, queryParams.toString());
    const defaultPayType = 'ali-h5'; //'wx-jsapi'
    const payType = queryParams['payType'] || (isRenewal ? 'auto' : defaultPayType);
    // 判断当前支付方式是否与浏览器环境不兼容
    let needJumpInnerQr = false;
    // const isNoPayType = !queryParams['payType'];
    if (payType !== 'auto') {
      if (payType.startsWith('wx') && !envResult.isWeChatBrowser) {
        // payType = 'qr-code';
        needJumpInnerQr = true;
      } else if (payType.startsWith('ali') && envResult.isWeChatBrowser) {
        // payType = 'qr-code';
        needJumpInnerQr = true;
      }

      // 环境不兼容：跳内部哈希路由 /#/tax/qr，强制 payType=auto
      // if (needJumpInnerQr) {
      //   queryString.delete('payType');
      //   queryString.set('payType', 'auto');
      //   const targetInnerUrl = `/#/tax/qr?${queryString.toString()}`;
      //   console.log('[RouteInterceptor] 环境不兼容，跳转内部二维码页：', targetInnerUrl);
      //   document.location.href = targetInnerUrl;
      //   return false;
      // }
      if (needJumpInnerQr) {
        // 强制设置payType=auto，携带所有原有参数
        queryString.delete('payType');
        queryString.set('payType', 'auto');
        const targetQuery: Record<string, string> = {};
        queryString.forEach((value, key) => {
          targetQuery[key] = value;
        });
        const urlTree = router.parseUrl('/tax/eliboo-pay/qr');
        urlTree.queryParams = targetQuery;

        console.log('[RouteInterceptor] 环境不兼容，单页跳转内部二维码页', urlTree.toString());
        return urlTree;
      }

      // if (payType === 'qr-code') {
      //   console.log('[RouteInterceptor] 查询参数:', queryString, isNoPayType);
      //   queryString.delete('payType');
      //   if (isNoPayType) {
      //     queryString.append('payType', 'auto');
      //   }
      //   return router.parseUrl(`/qr-code-pay?${queryString.toString()}`);
      // }
    }

    queryString.delete('originUrl');
    console.log('queryString', queryString);

    // 不是引立播需转换成引立播
    const url = originUrl + '?' + queryString.toString();
    console.log('[RouteInterceptor] 重定向URL:', url);
    document.location.href = url;
    return false;
  } catch (error) {
    console.error('[RouteInterceptor] 路由拦截错误:', error);
    // 发生错误时允许访问，避免阻塞用户
    return true;
  }
};

/**
 * 检查是否为 eliboo-pay 路由
 */
function isElibooPayRoute(path: string): boolean {
  return path.startsWith('/tax/eliboo-pay') && !path.includes('/qr');
}
